var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48025 0H0.804598C0.360393 0.000799523 0.000523825 0.550073 0 1.22807V9.30967C0.000523825 9.98766 0.360393 10.5369 0.804598 10.5377H7.48025C7.92435 10.5369 8.28432 9.98766 8.28484 9.30967V1.22807C8.28432 0.550073 7.92435 0.000799523 7.48025 0Z",
    className: "purple"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82129 6.81718L11.5863 9.12125V1.17542L8.82129 3.47949V6.81718Z",
    className: "purple"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.7911e1439efb40266a7f0a01415c7edc.svg";
export { ForwardRef as ReactComponent };